import { vars } from 'src/core/themes';
export const PingDot = (props: any) => {
  const { cx, cy } = props;
  return (
    <svg width="100%" height="100%">
      <circle
        cx={cx}
        cy={cy}
        r="4"
        fill="none"
        stroke={vars.color.textBrand}
        strokeWidth="1"
      >
        <animate
          attributeName="r"
          values="4;12"
          dur="2s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="opacity"
          values="1;0"
          dur="2s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx={cx} cy={cy} r="5" fill={vars.color.textBrand} />
    </svg>
  );
};
